import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Fab from "@mui/material/Fab";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import ForumIcon from "@mui/icons-material/Forum";
import styled from "@mui/material/styles/styled";
import { Button } from "../Button";
import { useMediaQuery, useTheme } from "@mui/material";
const StyleWrapper = styled(Box)(({ theme }) => {
    return {
        ".product-wrapper_component section": {
            margin: "0px auto"
        },
        "&.card-wrapper": {
            maxWidth: "100%",
            margin: "0px auto",
            paddingBottom: 50,
            ".MuiTabs-flexContainer": {
                justifyContent: "space-around",
            },
            ".MuiCardContent-root .MuiButtonBase-root": {
                background: "#fff !important",
                color: "#162242",
            },
            ".MuiTabs-indicator": {
                backgroundColor: "#162242",
            },
            ".MuiTabs-scroller": {
                borderBottom: "1px solid #999999",
                zIndex: "0"
            },
            ".MuiPaper-root": {
                padding: 0,
                border: "none",
            },
            ".product-wrapper_title span": {
                fontFamily: "Roboto",
                fontSize: 42,
                textTransform: "uppercase",
                fontWeight: "100"
            },
            "#product-wrapper_component": {
                minHeight: "40vh",
            },
            ".product-wrapper_footer": {
                display: "flex",
                background: "#f7f7f7",
                borderTop: "1px solid #bdbdbd",
                padding: 10,
                textAlign: "right",
                ".MuiButton-root": {
                    borderRadius: "50px",
                    color: "#fff",
                    backgroundColor: "#4285f4",
                    boxShadow: "0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12)",
                    transition: "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                    padding: "0.84rem 2.14rem",
                    fontSize: ".81rem",
                },
                ".Mui-disabled": {
                    backgroundColor: "#e3e3e3",
                    borderColor: "#e3e3e3",
                },
            },
            p: {
                margin: 0,
            },
            ".product-wrapper_footer-text": {
                margin: 0,
                fontFamily: "Roboto",
                fontSize: 14,
                whiteSpace: "pre",
                fontWeight: "normal",
                fontStretch: "normal",
                fontStyle: "normal",
                lineHeight: 1.14,
                letterSpacing: "normal",
                color: "#333333",
                padding: "2px 0",
            },
            ".need-help-wrapper": {
                display: "flex",
                gap: 10,
                div: {
                    b: {
                        fontSize: 14,
                    },
                },
            },
        },
        [theme.breakpoints.down(1024)]: {
            "#product-wrapper_component": {
                overflow: "auto"
            },
        },
        [theme.breakpoints.down(770)]: {
            "&.card-wrapper": {
                paddingBottom: "0px",
            },
            "#product-wrapper_component": {
                minHeight: "55vh !important",
                display: 'flex'
            },
        },
    };
});
export const CardWrapper = (props) => {
    var _a, _b;
    const theme = useTheme();
    const showText = useMediaQuery(theme.breakpoints.up("md"));
    return (React.createElement(StyleWrapper, { className: "card-wrapper" },
        React.createElement(Card, { variant: "outlined" },
            showText && props.title ? (React.createElement(CardHeader, { title: props.title, className: "product-wrapper_title" })) : null,
            React.createElement(CardContent, null,
                React.createElement("div", { id: "product-wrapper_component" }, React.createElement(props.Component, null))),
            showText && (React.createElement(CardActions, { className: "product-wrapper_footer", sx: {
                    justifyContent: ((_a = props.buttons) === null || _a === void 0 ? void 0 : _a.length)
                        ? "space-between"
                        : "flex-end",
                } },
                React.createElement("div", { className: "btn-wrapper" }, (_b = props.buttons) === null || _b === void 0 ? void 0 : _b.map((btn) => (React.createElement(Button, Object.assign({}, btn))))),
                React.createElement("div", { className: "need-help-wrapper" },
                    props.footerText ? (React.createElement("div", null,
                        React.createElement("b", null, "Need help?"),
                        React.createElement("p", { className: "product-wrapper_footer-text", style: { marginTop: 0 }, dangerouslySetInnerHTML: { __html: props.footerText } }))) : null,
                    props.showChatIcon === false ? null : (React.createElement("div", { className: "product-wrapper_footer-chat" },
                        React.createElement(Fab, { "aria-label": "add", sx: { background: "#fb6647", color: "#fff", zIndex: 0 }, onClick: () => props.openChatMethod() },
                            React.createElement(ForumIcon, { sx: { color: "#fff" } }))))))))));
};
